import React from "react";
import { VEHICLE_TYPES, vehicleTypeBadgeClass, vehicleTypeLabel } from "../vehicleTypes";

// The one Vehicle Type <select> used on the master form and as the filter on every
// vehicle-related report (Vehicles list, Maintenance Report, Fuel Transactions /
// Exceptions / Reports, Vehicle Fuel Setup, One Stop). `allLabel` turns it into a
// filter with an "All types" first option; without it, it is the form field.
const VehicleTypeSelect = ({ value, onChange, allLabel, disabled, className = "form-control", style, id }) => (
  <select
    id={id}
    className={className}
    style={style}
    value={value ?? ""}
    onChange={(e) => onChange(e.target.value)}
    disabled={disabled}
    aria-label="Vehicle type"
  >
    <option value="">{allLabel || "--Select type--"}</option>
    {VEHICLE_TYPES.map((t) => (
      <option key={t.value} value={t.value}>{t.label}</option>
    ))}
  </select>
);

export const VehicleTypeBadge = ({ code }) =>
  code ? <span className={`badge ${vehicleTypeBadgeClass(code)}`}>{vehicleTypeLabel(code)}</span> : null;

export default VehicleTypeSelect;
